import React from 'react';
import { NavLink } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { Root, Establishments, Customers, Accounts, Inventory, MyAccount, OperatorSettings, Documentation, Requests, Workstations } from '../../../modules/Navigation';

export interface ISideMenuItem {
    text: string,
    icon: any,
    navigateTo: any,
    className?: string
}

export default function NavMenuItem({ text, icon, navigateTo, className }: ISideMenuItem) {
    const location = useLocation();

    function checkNavigationPathAgainstParent(path: string): boolean {
        switch (navigateTo) {
            case Root.to:
                if (path === '/') {
                    return true
                }
                return false;
            case Establishments.to:
                if (path.includes(Establishments.to) || path.includes(Customers.to) || path.includes(Accounts.to)) {
                    return true
                }
                return false;
            case Customers.to:
                if (path.includes(Customers.to)) {
                    return true
                }
                return false;
            case Inventory.to:
                if (path.includes(Inventory.to)) {
                    return true
                }
                return false;
            case Requests.to:
                if (path.includes(Requests.to)) {
                    return true
                }
                return false;
            case Accounts.to:
                if (path.includes(Accounts.to)) {
                    return true
                }
                return false;
            case OperatorSettings.to:
                if (path.includes(OperatorSettings.to)) {
                    return true
                }
                return false;
            case MyAccount.to:
                if (path.includes(MyAccount.to)) {
                    return true
                }
                return false;
            case Documentation.to:
                if (path.includes(Documentation.to)) {
                    return true;
                }
                return false;
            case Workstations.to:
                if (path.includes(Workstations.to)) {
                    return true;
                }
                return false;
            default:
                return false
        }
    }

    return <NavLink to={navigateTo}>
        <div data-testId={navigateTo} className={`nav-menu__item ${checkNavigationPathAgainstParent(location.pathname) ? "active" : ""} ${className ? className : ''} `}>
            <img className={"nav-menu__active-icon margin__left--xxxs"} src={icon} />
            <p className={"nav-menu__item__text"}>
                {text}
            </p>

        </div>
    </NavLink>
}